export enum TDialogSizes {
  Small = "sm",
  Medium = "md",
  Large = "lg",
  ExtraLarge = "xl",
  Full = "full",
  Liquid = "liquid",
}
